import { clsx } from "clsx";
import { ChangeEvent, useState } from "react";
import { useDispatch } from "react-redux";
import { reportGifById } from "store/video/video-action";
import { ReportStepOne } from "./ReportStepOne";
import { ReportStepTwo } from "./ReportStepTwo";
import { Popup } from "components/UI/Popup";
import "./styles/ReportPopup.scss";

interface IProps {
  isOpen: boolean;
  togglePopup: () => void;
  gifId: string;
  handleMainPopup: () => void;
}

export interface IReason {
  value: number;
  text: string;
}

const REPORT_REASONS: IReason[] = [
  { value: 0, text: "Underaged / people" },
  { value: 1, text: "Racist/offensive language/acts" },
  { value: 2, text: "Animals/acts of Bestiality" },
  { value: 3, text: "Rape/Sexual assault" },
  { value: 4, text: "Violence/Death/Disturbing" },
  { value: 5, text: "Copyright / I own this content" },
  { value: 6, text: "I am in this GIF" },
  { value: 7, text: "Other" },
];

export const ReportPopup = (props: IProps) => {
  const { isOpen, togglePopup, gifId, handleMainPopup } = props;
  const [reportReason, setReportReason] = useState<IReason>(REPORT_REASONS[0]);
  const [reportMessage, setReportMessage] = useState<string>("");
  const [isCanContact, setIsCanContact] = useState<boolean>(false);
  const dispatch = useDispatch();

  const handleReportMessage = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setReportMessage(event.target.value);
  };

  const handleIsCanContact = () => {
    setIsCanContact(!isCanContact);
  };

  const [currentStep, setCurrentStep] = useState<number>(0);

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const handleToggle = () => {
    setCurrentStep(0);
    setReportMessage("");
    setReportReason(REPORT_REASONS[0]);
    setIsCanContact(false);
    togglePopup();
    handleMainPopup();
  };

  const report = () => {
    dispatch(reportGifById({
      gifId: gifId,
      option: reportReason.value,
      message: reportMessage,
      canContact: isCanContact,
      email: ""
    }));
    handleToggle();
  };

  const btnProps = {
    type: 1,
    title: currentStep === 0 ? "Next" : "Submit",
    onClick: currentStep === 0 ? nextStep : report
  };

  const popupClx = clsx(
    "ReportPopup",
    { "ReportPopup_StepOne": currentStep === 0 },
    { "ReportPopup_StepTwo": currentStep === 1 },
  );

  return (
    <Popup
      title="Report GIF"
      isOpen={isOpen}
      popupClass={popupClx}
      btnProps={btnProps}
      onClose={handleToggle}
    >
      {currentStep === 0 && (
        <ReportStepOne
          reportReasons={REPORT_REASONS}
          reportReason={reportReason}
          setReportReason={setReportReason}
          nextStep={nextStep}
        />
      )}
      {currentStep === 1 && (
        <ReportStepTwo
          comment={reportMessage}
          onChangeComment={handleReportMessage}
          isCanContact={isCanContact}
          handleIsCanContact={handleIsCanContact}
          report={report}
        />
      )}
    </Popup>
  );
};
